// src/modules/auth/routes/auth.routes.tsx
import React from "react";
import { RouteObject, Outlet } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage";
import { RegisterPage } from "../pages/RegisterPage";
import { AuthLandingPage } from "../pages/AuthLandingPage";
import { PasswordChangePage } from "../pages/PasswordChangePage";
import { AuthProvider } from "../AuthProvider";
import { CashierLoginPage } from "../pages/CashierLoginPage";

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>;
};

export const authRoutes: RouteObject[] = [
  {
    path: "/auth",
    element: (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    ),
    children: [
      {
        index: true,
        element: <AuthLandingPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "change-password",
        element: <PasswordChangePage />,
      },
      {
        path: "cashier-login",
        element: <CashierLoginPage />,
      },
    ],
  },
];
